import styled from 'styled-components';
import theme from '@/theme';

export interface CardHighlightProps {
  positive?: boolean;
  negative?: boolean;
}

/*
  USED JUST TO HIGHLIGH NUMBERS OR ICONS
*/
export const CardHighlight = styled.div<CardHighlightProps>`
  font-size: 2.6rem;
  ${props => props.positive && `color: ${theme.colors.themePrimary};`}
  ${props => props.negative && `color: ${theme.colors.themeError};`}
`;
